(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tcgcase-product-colors"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tcgcase-product-colors')) customElements.define('tcgcase-product-colors',class extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse(this.querySelector('[data-color-data]').textContent);
      this.section = this.closest('.shopify-section');
      this.change = event => { if (event.target.closest('variant-picker')) this.update(); };
      this.section?.addEventListener('change',this.change);
      this.update();
    }
    disconnectedCallback() { this.section?.removeEventListener('change',this.change); }
    update() {
      const select = this.section?.querySelector('variant-picker select');
      if (!select) return;
      const key = value => value.trim().replace(/\s+/g,' ').toLowerCase();
      const model = key(select.value);
      this.querySelectorAll('.tcgp-colors__item').forEach((item,index) => {
        const product = this.data.products[index];
        const variant = product.variants.find(v => key(v.model) === model);
        if (variant?.available) { item.href = variant.url; item.removeAttribute('aria-disabled'); }
        else { item.removeAttribute('href'); item.setAttribute('aria-disabled','true'); }
        if (product.handle === this.data.current) item.setAttribute('aria-current','true');
        else item.removeAttribute('aria-current');
        item.querySelector('.tcgp-colors__status').textContent = !variant ? this.data.notMade : variant.available ? '' : this.data.soldOut;
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
